import { render, staticRenderFns } from "./ConfigCreditAnalysisGrandesNegocios.vue?vue&type=template&id=42ab51f2&scoped=true&"
import script from "./ConfigCreditAnalysisGrandesNegocios.vue?vue&type=script&lang=js&"
export * from "./ConfigCreditAnalysisGrandesNegocios.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCreditAnalysisGrandesNegocios.vue?vue&type=style&index=0&id=42ab51f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ab51f2",
  null
  
)

export default component.exports